// extracted by mini-css-extract-plugin
export var change = "_3h-1";
export var changeList = "_3h-0";
export var changePath = "_3h-2";
export var diffArrow = "_3h-5";
export var diffRow = "_3h-3";
export var diffValue = "_3h-4";
export var error = "_3h-8";
export var notice = "_3h-9";
export var result = "_3h-6";
export var success = "_3h-7";